<template>
  <div>
    <a-form layout="vertical">
      <a-row v-bind:gutter="16">
        <a-col v-bind:span="12">
          <a-form-item label="Opleverdatum">
            <date-picker-component v-bind:disabled="disabled"
                                   v-bind:block="true"
                                   v-model="currentLivingCondition.date_of_delivery"
                                   v-on:change="onChange"
            />
          </a-form-item>
        </a-col>
        <a-col v-bind:span="12">
          <a-form-item label="VvE">
            <a-radio-group button-style="solid"
                           v-bind:disabled="disabled"
                           v-model="currentLivingCondition.owners_association"
                           v-on:change="onChange">
              <a-radio-button v-bind:value="true">
                Ja
              </a-radio-button>
              <a-radio-button v-bind:value="false">
                Nee
              </a-radio-button>
            </a-radio-group>
          </a-form-item>
        </a-col>
      </a-row>
      <a-row v-bind:gutter="16">
        <a-col v-bind:span="12">
          <a-form-item label="Servicekosten">
            <a-input
                prefix="€"
                type="number"
                v-on:change="onChange"
                v-model="currentLivingCondition.service_costs"
                placeholder=""
            />
          </a-form-item>
        </a-col>
        <a-col v-bind:span="12">
        </a-col>
      </a-row>
    </a-form>
  </div>
</template>

<script>
import customerCurrentLivingConditionApi from "~/api/customer_current_living_condition";

export default {
  name: "CustomerCurrentLivingConditionEditComponent",
  props: {
    value: {
      required: true,
      type: Object
    },
    autoSave: {
      type: Boolean,
      required: false,
      default: false
    },
    disabled: {
      type: Boolean,
      required: false,
      default: false
    },
    withAddressType: {
      type: Boolean,
      required: false,
      default: true
    }
  },
  data() {
    return {
      form: this.$form.createForm(this),
      currentLivingCondition: this.value,
      property_type: {},
      property_purpose: {},
      persistTimeout: 0,
    };
  },
  computed: {},
  mounted() {
    customerCurrentLivingConditionApi.getPropertyTypeList().then(response => {
      this.property_type = response.data;
    })
    customerCurrentLivingConditionApi.getPropertyPurposeList().then(response => {
      this.property_purpose = response.data;
    })
  },
  methods: {
    onChange() {
      this.$emit('input', this.currentLivingCondition);
      this.$emit('change', this.currentLivingCondition);

      if (this.autoSave) {
        this.save();
      }
    },
    save() {
      clearTimeout(this.persistTimeout);

      this.persistTimeout = setTimeout(() => {
        customerCurrentLivingConditionApi.update(this.currentLivingCondition).then(() => {
          this.$emit('save', this.currentLivingCondition);
        }).catch((error) => {
          this.$message.error('Er ging iets fout tijdens het opslaan');
          this.$emit('error', error);
        });
      }, 500);
    },
  }
}
</script>
<style scoped>
.search-component {
  position: relative;
}

.search-component .results {
  position: absolute;
  width: calc(100% - 10px);
  background: rgba(255, 255, 255, 0.91);
  margin: 5px;
  max-height: 300px;
  overflow: auto;
}
</style>
